import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const pictureShadowColor: AdminBlockTypeAttribute = {
  label: 'Show picture shadow color',
  key: 'pictureShadowColor',
  inputType: AdminBlockAttributeInputType.COLOR_PICKER,
};

export default pictureShadowColor;
